  /* eslint-disable */
  
  export const today = new Date(new Date().toDateString());
  export const weekEnd = new Date(new Date(new Date().setDate(new Date().getDate()-7)).toDateString())
  export const monthStart = new Date(new Date(new Date().setDate(new Date().getDate()-30)).toDateString());
  export const yearStart = new Date(new Date(new Date().getFullYear() - 1, 0, 1).toDateString());
  export const yearEnd = new Date(new Date(new Date().getFullYear() - 1, 11, 31).toDateString());
  export const yesterday = new Date(new Date(new Date().setDate(new Date().getDate()-1)).toDateString())

  export const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }